import React, { useState } from "react";
import { Row, Col, Card, Form, Input, Spin, PageHeader, Alert, Select } from "antd";
import { useSelector } from "react-redux";
import TransactionResume from "../../components/Dialog/transaction-resume";
import { useCashoutGetInfoMoreMutation, useCashoutMoreMutation } from "./service/cashout-service";
import CustomBtn from "../../components/Button";
import SuccessDialog from "../../components/Dialog/success";
import { useBillFeesMutation } from "../bills/service/bill-api";

export function CashoutMorePage() {
    const { currentAgent } = useSelector((state) => state.auth);
    const [cashoutGetInfoMore] = useCashoutGetInfoMoreMutation();
    const [cashoutMore] = useCashoutMoreMutation();
    const [billFees] = useBillFeesMutation();
    const [show, setShow] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState();
    const [isCustomer, setIsCustomer] = useState(false);
    const [beneficiaryIdType, setBeneficiaryIdType] = useState();
    const [fees, setFees] = useState();
    const [formdata, setFormData] = useState();
    const [form] = Form.useForm();

    const handleSearch = async (value) => {
        setIsLoading(true);
        const data = {
            "agent_msisdn": currentAgent.phone,
            "order_ref": value.order_ref,
            "country": currentAgent.country,
            "token": currentAgent.access_token,
            "service": "MORE",
            "pincode": "",
        };

        cashoutGetInfoMore(data)
            .unwrap()
            .then((res) => {
                setIsLoading(false);
                setError();
                setFormData(res)
                form.setFieldsValue({
                    beneficiary_first_name: res.beneficiary_first_name,
                    beneficiary_last_name: res.beneficiary_last_name,
                    amount: res.amount,
                });
            })
            .catch((error) => {
                setIsLoading(false);
                setError(error.data.error);
            });
    };

    const handleFees = async (value) => {
        setIsLoading(true);
        const data = {
            agent_msisdn: currentAgent.phone,
            country: currentAgent.country,
            pincode: "",
            montant: parseInt(value.amount),
            operation: "B2W",
            service: "MORE",
            token: currentAgent.access_token,
        };
        setBeneficiaryIdType(value.beneficiary_id_type)
        billFees(data)
            .unwrap()
            .then((res) => {
                setIsLoading(false);
                setError();
                setFees(res);
                setShow(true);
            })
            .catch((error) => {
                setIsLoading(false);
                setError(error.data.error);
            });
    };

    const handlePay = async (pin) => {
        setIsLoading(true);
        setShow(false);
        const data = {
            "agent_msisdn": currentAgent.phone,
            "agent_pin": pin,
            "order_ref": formdata.order_ref,
            "order_id": formdata.order_id,
            "amount": formdata.amount,
            "beneficiary_id_type": parseInt(beneficiaryIdType),
            "beneficiary_id_number": formdata.beneficiary_id_number,
            "country": currentAgent.country,
            "beneficiary_expiration": formdata.beneficiary_expiration,
            "beneficiary_address": formdata.beneficiary_address,
            "beneficiary_city": formdata.beneficiary_city,
            "beneficiary_phone": formdata.beneficiary_phone,
            "beneficiary_first_name": formdata.beneficiary_first_name,
            "beneficiary_last_name": formdata.beneficiary_last_name,
            "token": currentAgent.access_token,
            "service": "MORE",
        };
        cashoutMore(data)
            .unwrap()
            .then(() => {
                setIsSuccess(true);
                setIsLoading(false);
                setIsCustomer(false);
                form.resetFields();
                setFormData()
            })
            .catch((error) => {
                setIsLoading(false);
                setError(error.data.error);
            });
    };

    return (
        <div className="default-page">
            <TransactionResume
                title="RETRAIT MORE"
                message={
                    "Vous allez effectuer un retrait MORE d'un montant de " +
                    fees?.amount +
                    " F CFA"
                }
                fees={fees?.fees}
                status={show}
                handleCancel={() => setShow(false)}
                handlePay={handlePay}
            />
            <SuccessDialog
                message="Retrait effectué avec succès"
                status={isSuccess}
                handleCancel={() => setIsSuccess(false)}
            />
            <PageHeader title="RETRAIT MORE" />
            <Spin tip="Chargement..." spinning={isLoading}>
                <Row gutter={16}>
                    <Col lg={12} xs={24}>
                        <Card>
                            <Form name="basic" form={form} layout="vertical" onFinish={formdata ? handleFees : handleSearch}>
                                <Form.Item
                                    label="Numéro de référence"
                                    name="order_ref"
                                    rules={[{ required: true, message: "Veuillez saisir le numéro de référence" }]}>
                                    <Input className="form-control" placeholder="Numéro de référence" />
                                </Form.Item>
                                {
                                    formdata &&
                                    <div>
                                        <Form.Item
                                            label="Nom du bénéficiaire"
                                            name="beneficiary_first_name">
                                            <Input className="form-control" placeholder="Numéro de référence" />
                                        </Form.Item>

                                        <Form.Item
                                            label="Prénom du bénéficiaire"
                                            name="beneficiary_last_name">
                                            <Input className="form-control" placeholder="Numéro de référence" />
                                        </Form.Item>

                                        <Form.Item
                                            label="Montant"
                                            name="amount">
                                            <Input className="form-control" placeholder="Numéro de référence" />
                                        </Form.Item>

                                        <Form.Item
                                            label="Type de piece d'identité"
                                            name="beneficiary_id_type">
                                            <Select
                                                options={[
                                                    {
                                                        value: '1',
                                                        label: "Carte d'identité",
                                                    },
                                                    {
                                                        value: '3',
                                                        label: 'Permis de conduire',
                                                    },
                                                    {
                                                        value: '523',
                                                        label: 'Passeport',
                                                    }
                                                ]}
                                            />
                                        </Form.Item>

                                        <Form.Item
                                            label="Numéro de piece d'identité"
                                            name="beneficiary_id_number">
                                            <Input className="form-control" placeholder="Numéro de piece d'identité" />
                                        </Form.Item>
                                    </div>
                                }

                                {error && (
                                    <Form.Item>
                                        <Alert message={error} type="error" showIcon />
                                    </Form.Item>
                                )}
                                <Form.Item>
                                    <CustomBtn title={formdata ? "Valider" : "Rechercher"} />
                                </Form.Item>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </Spin>
        </div>
    );
}
export default CashoutMorePage;
